import './css/dev.scss'

async function checkDevSettings() {
	if (await localStorage.getItem('isDev') == 'true' || process.env.NODE_ENV == 'development') {
		document.querySelector('html').classList.add('isDev')
	}
}

checkDevSettings()